import { KDrawerStyleConfig } from './KDrawer.types';

// update styles for different variants
export const drawerVariants: Record<string, KDrawerStyleConfig> = {
  //variant 1
  default: {
    content: {
      maxW: '400px',
    },
    header: {
      py: 4,
      px: 6,
      borderBottomWidth: '1px',
    },
    body: {
      // this wasn't working with chakra v1, but was affecting chakra v2, so commenting it out
      // we can remove later if we confirm it's not needed
      // py: 4,
      // px: 6,
    },
    footer: {
      py: 4,
      px: 6,
      borderTopWidth: '1px',
    },
  },
  //variant 2
  wide: {
    content: {
      maxW: '730px',
      borderTopLeftRadius: 'xl',
    },
  },
  //variant 3
  full: {
    content: {
      maxW: '85%',
      borderTopLeftRadius: 'xl',
    },
  },
  //variant 4
  max: {
    content: {
      maxW: '93%',
      borderTopLeftRadius: 'xl',
    },
  },
  // custom variant 1
  custom1: {
    content: {
      width: '83% !important',
      maxW: '1300px !important',
      borderTopLeftRadius: 'xl',
    },
  },
  // custom variant 2
  custom2: {
    content: {
      width: '90% !important',
      maxW: '1500px !important',
      borderTopLeftRadius: 'xl',
    },
  },
  // custom variant 3
  custom3: {
    content: {
      maxW: '1000px',
      borderTopLeftRadius: 'xl',
    },
  },

  // custom variant 2
  custom4: {
    content: {
      width: '90% !important',
      maxW: '1400px !important',
      borderTopLeftRadius: 'xl',
    },
  },
};

export const getVariantStyles = (
  variant: string = 'default'
): KDrawerStyleConfig => {
  return {
    ...drawerVariants.default,
    ...(drawerVariants[variant] || {}),
  };
};
